export default {
  xeroTenants: [],
  xeroTenant: undefined,
};
